import { importTxtFile } from "@/utils/txtdata";
import { getPassportList } from "@/api/assistant";
import { apiCallback } from "@/utils";
import { findLastIndex, isEmpty } from "lodash";

export const filePathList = [
    {
        name: "监管方式",
        path: "supvModeCdde",
        keyName: "supvModeCdde",
        type: "sdx",
    },
    {
        name: "运输方式",
        path: "shippingTypeList",
        keyName: "shippingTypeList",
        type: "sdx",
    },
    {
        path: "countryList",
        name: "国家", //英文简写对应中文
        keyName: "countryList",
        type: "sdx",
    },
    {
        path: "currencySystemList",
        name: "币制", //英文简写对应中文
        keyName: "currencySystemList",
        type: "sdx",
    },
    { name: "老国家代码", path: "countryNumList", keyName: "countryNumList" },
    {
        name: "国家英文",
        path: "countryEnList",
        keyName: "countryEnList",
        charsetType: "UTF-8",
    },
    { name: "出境关别", path: "exitCustomsList", keyName: "exitCustomsList" },
    { name: "集装箱", path: "preDecContainerVo", keyName: "preDecContainerVo" },
    { name: "成交方式", path: "transMethodList", keyName: "transMethodList" },
    { name: "包装种类", path: "packingList", keyName: "packingList" },
    { name: "单位", path: "unitList", keyName: "unitList" },
    {
        path: "destinationPortList",
        name: "指运港", //英文简写对应中文
        keyName: "destinationPortList",
    },
    {
        name: "指运港英文",
        path: "destinationPortEnList",
        keyName: "destinationPortEnList",
        charsetType: "UTF-8",
    },
    {
        name: "离境口岸",
        path: "departurePortList",
        keyName: "departurePortList",
    },
    {
        path: "documentsAttachedList",
        name: "监管条件",
        keyName: "documentsAttachedList",
    },
];

// const isEmpty = (data) => {
//     if (data && Array.isArray(data)) {
//         return !Boolean(data.length);
//     }
//     if (data && Object.keys(data).length > 0) {
//         return false;
//     }
//     return true;
// };

// 存储文件数据
export const importTxtDataToJSON = () => {
    return new Promise(async (resolve, reject) => {
        const promise = [];
        const txtVersionKey = "fcw-local-txt-version";
        const localTxtVersionMap = localStorage.getItem(txtVersionKey);
        const txtDataKey = "fcw-form-txt-data";
        const localTxtDataStr = localStorage.getItem(txtDataKey);
        let localTxtDataJson = {};
        if (localTxtDataStr) {
            localTxtDataJson = JSON.parse(localTxtDataStr);
        }
        // 请求线上版本,带时间戳，最新的
        fetch(
            `https://web.nbhuojian.com/static/shendanxia_web/txt/txtDataVersion.json?t=${new Date().getTime()}`,
        )
            .then((res) => res.json())
            .then(async (onlineVersionParse) => {
                // 需要加载的txt文档
                let needRequestFilePathList = [];
                // 如果本地不存在的话，那就把线上的版本存进去
                if (!localTxtVersionMap || isEmpty(localTxtVersionMap)) {
                    needRequestFilePathList = filePathList;
                } else {
                    // 看看本地版本是否和线上版本有冲突的，
                    const localTxtVersionMapParse =
                        JSON.parse(localTxtVersionMap);
                    if (localTxtDataStr) {
                        localTxtDataJson = JSON.parse(localTxtDataStr);
                    }
                    filePathList.forEach((item) => {
                        const localVersion =
                            localTxtVersionMapParse[item.keyName];
                        const onlineVersion = onlineVersionParse[item.keyName];
                        // 如果线上或者本地版本存在，但是版本号不同，那么就需要重新请求
                        if (
                            !localVersion ||
                            !onlineVersion ||
                            (onlineVersion &&
                                localVersion &&
                                localVersion !== onlineVersion)
                        ) {
                            needRequestFilePathList.push(item);
                        } else if (
                            !localTxtDataStr ||
                            isEmpty(localTxtDataJson) ||
                            (!isEmpty(localTxtDataJson) &&
                                !localTxtDataJson[item.keyName])
                        ) {
                            needRequestFilePathList.push(item);
                        }
                    });
                }
                localStorage.setItem(
                    txtVersionKey,
                    JSON.stringify(onlineVersionParse),
                );
                needRequestFilePathList.forEach((item) => {
                    promise.push(
                        importTxtFile(
                            `txt/${item.path}.txt`,
                            item.keyName,
                            item.charsetType,
                        ),
                    );
                });
                Promise.all(promise).then((value) => {
                    // const txtDataStore = useTxtDataStore();
                    const needSetValue = Object.fromEntries(value) || {};
                    const setTxtValue = {
                        ...localTxtDataJson,
                        ...needSetValue,
                    };

                    localStorage.setItem(
                        txtDataKey,
                        JSON.stringify(setTxtValue),
                    );
                    // that.$store.commit("/txtdata/changeTxtData", {
                    //     ...setTxtValue,
                    // });
                    resolve({
                        ...setTxtValue,
                    });
                });
            });
    });
};

// 根据IEPort获取关区
export const getCustomsByIEPort = (iEPort) => {
    let searchType = "NB";
    if (iEPort) {
        if (iEPort.startsWith("22")) {
            searchType = "SH";
        } else if (iEPort.startsWith("53")) {
            searchType = "SZ";
        }
    }
    return searchType;
};

// 计算字符串字节数
export function countCharsBtytes(text, options = { ignoreSpaces: false }) {
    let processedText = text;
    if (options.ignoreSpaces) {
        processedText = processedText.replace(/\s/g, "");
    }
    return processedText.replace(/[^\x00-\xff]/g, "01").length;
}

// 校验字符串长度是否小于255字符（备注，唛头，申报要素,境外收货人）
export function checkLess255Str(value, msg, needMsg = true, number = 255) {
    if (value === "") {
        return true;
    }
    if (countCharsBtytes(value) > number) {
        return false;
    }
    return true;
}

// 去除所有标点符号和空格
export function removePunctuation(str) {
    // 先去除所有空格
    const strData = str.replace(/\s/g, "");
    try {
        return strData.replace(/\p{P}/gu, "");
    } catch (e) {
        return strData.replace(/[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/g, "");
    }
}

// 校验日期是否合法
export function validateDate(dateString) {
    // 检查是否符合8位数字格式要求
    if (!/^\d{8}$/.test(dateString)) {
        return false;
    }

    // 解析年月日
    const year = parseInt(dateString.slice(0, 4), 10);
    const month = parseInt(dateString.slice(4, 6), 10);
    const day = parseInt(dateString.slice(6, 8), 10);

    // 检查月份是否在有效范围内（1-12）
    if (month < 1 || month > 12) {
        return false;
    }

    // 创建日期对象
    const date = new Date(year, month - 1, day);

    // 验证日期是否有效
    return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
    );
}

// 校验cas号
export function checkCAS(cas, codeTs) {
    if (codeTs && ["28", "29"].includes(codeTs.substring(0, 2)) && !cas) {
        return "HS开头是28,29章的，需要填写CAS号";
    }
    if (!cas) {
        return "";
    }
    if (cas == "无CAS号") {
        return "";
    }
    var casArray = cas.split("-");
    if (casArray == null || casArray.length != 3) {
        return "CAS号格式异常";
    }
    if (
        !(
            casArray[0].length >= 2 &&
            casArray[1].length == 2 &&
            casArray[2].length == 1
        )
    ) {
        return "CAS号格式异常";
    }
    var firstCas = casArray[0] + casArray[1];
    var sum = 0;
    for (var i = firstCas.length - 1; i >= 0; i--) {
        sum += Number(firstCas.substring(i, i + 1)) * (firstCas.length - i);
    }
    if (sum % 10 == Number(casArray[2])) {
        return "";
    }
    return "CAS号校验码异常";
}

// 校验GTIN
export function checkGTIN(gtin) {
    if (!gtin) {
        return "";
    }
    if (gtin.length !== 8 && gtin.length !== 12 && gtin.length !== 13) {
        return "GTIN的位数必须是13位、12位或8位";
    }
}

// 校验规格型号
export const checkGModel = (param) => {
    const { gModel, elementKey, codeTs, isNeedColShortName = false } = param;
    let gModelArr = [];
    let elementKeyArr = [];
    let colShortNameArr = [];
    if (Array.isArray(gModel)) {
        gModelArr = gModel;
    } else if (gModel) {
        gModelArr = gModel.split("|");
    }
    gModelArr = gModelArr.map((gModelItem) => gModelItem.trim());
    if (Array.isArray(elementKey)) {
        elementKeyArr = elementKey;
    } else if (elementKey) {
        elementKeyArr = elementKey.split("||") || [];
    }
    console.log(elementKeyArr, "elementKeyArr");
    // 错误合集
    const errorMsgList = [];
    const isImport = false;
    // 校验必填项
    // 一般情况下，非必填项:GTIN CAS 其他
    for (let i = 0; i < elementKeyArr.length; i++) {
        const curElementKey = elementKeyArr[i];
        const curGModel = gModelArr[i];
        if (!["GTIN", "CAS", "其他"].includes(curElementKey)) {
            if (!curGModel) {
                const msg = `申报要素-${curElementKey} 不能为空`;
                errorMsgList.push(msg);
                colShortNameArr.push(curElementKey);
            }
        }
        // hscode 28 29 开头，CAS必填
        if (codeTs && ["28", "29"].includes(codeTs.substring(0, 2))) {
            if (curElementKey === "CAS" && !curGModel) {
                const msg = `【28，29】开头的商品，申报要素CAS号不能为空`;
                errorMsgList.push(msg);
                colShortNameArr.push("CAS");
            }
        }
    }

    if (!checkLess255Str(gModelArr.join("|"))) {
        errorMsgList.push("申报要素长度不能超过255个字符");
    }
    if (!isEmpty(elementKeyArr) && elementKeyArr.includes("品牌类型")) {
        const arr1 = isImport
            ? ["0", "1", "2", "4"]
            : ["0", "1", "2", "3", "4"];
        // 品牌类型错误
        const cindex = findLastIndex(elementKeyArr, (item) =>
            item.includes("品牌类型"),
        );
        if (!arr1.includes(gModelArr[cindex])) {
            const msg = "申报要素品牌类型错误";
            errorMsgList.push(msg);
            colShortNameArr.push(elementKeyArr[cindex]);
        }
    }
    if (!isEmpty(elementKeyArr) && elementKeyArr.includes("享惠类型")) {
        const arr2 = isImport ? ["3"] : ["0", "1", "2"];
        const cindex = findLastIndex(elementKeyArr, (item) =>
            item.includes("享惠类型"),
        );
        if (!arr2.includes(gModelArr[cindex])) {
            const msg = "申报要素享惠类型错误";
            errorMsgList.push(msg);
            colShortNameArr.push(elementKeyArr[cindex]);
        }
    }

    // 签约日期
    if (!isEmpty(elementKeyArr) && elementKeyArr.includes("签约日期")) {
        // 获取签约日期出现的位置
        const cindex = elementKeyArr.findIndex((item) =>
            item.includes("签约日期"),
        );
        const dateValue = gModelArr[cindex];
        if (!validateDate(dateValue)) {
            const msg = "申报要素签约日期格式必须为类似 20230802格式";
            errorMsgList.push(msg);
            colShortNameArr.push(elementKeyArr[cindex]);
        }
    }
    console.log(!isEmpty(elementKeyArr), "!isEmpty(elementKeyArr)");
    // CAS号
    if (!isEmpty(elementKeyArr) && elementKeyArr.includes("CAS")) {
        console.log(gModelArr, "gModelArr");
        const cindex = elementKeyArr.findIndex((item) => item.includes("CAS"));
        const casValue = gModelArr[cindex];
        const casErrorMsg = checkCAS(casValue, codeTs);
        if (casErrorMsg) {
            const msg = casErrorMsg + ",格式必须为类似 82212-14-4格式";
            errorMsgList.push(msg);
            colShortNameArr.push(elementKeyArr[cindex]);
        }
    }
    // GTIN号
    if (!isEmpty(elementKeyArr) && elementKeyArr.includes("GTIN")) {
        const cindex = elementKeyArr.findIndex((item) => item.includes("GTIN"));
        const gtinValue = gModelArr[cindex];
        const gtinErrorMsg = checkGTIN(gtinValue);
        if (gtinErrorMsg) {
            const msg = gtinErrorMsg;
            errorMsgList.push(msg);
            colShortNameArr.push(elementKeyArr[cindex]);
        }
    }

    if (isNeedColShortName) {
        return {
            colShortNameArr,
            errorMsgList,
        };
    }
    return errorMsgList;
};

// 基础选择完成
export const handleBaseSelectChange = ({ val, item, that }) => {
    const handleOutbordTrafMode = () => {
        // 2的时候:集卡车牌号(牵引车) 集装箱号必填
        // 3的时候:铁路运输车皮号 集装箱号必填
        // 4的时候:货车车牌号 集卡车牌号(牵引车)必填
        // 5的时候:空运航空航次号 必填
        that.$refs.formRef && that.$refs.formRef.clearValidate();
        const baseMustInput = {
            required: true,
            trigger: "change",
        };
        const trainNoMustInput = {
            ...baseMustInput,
            message: `铁路运输车皮号不能为空`,
        };
        const flightNoMustInput = {
            ...baseMustInput,
            message: `空运航空航次号不能为空`,
        };
        const truckNoMustInput = {
            ...baseMustInput,
            message: `货车车牌号不能为空`,
        };
        const tractorNoMustInput = {
            ...baseMustInput,
            message: `集卡车牌号(牵引车)不能为空`,
        };
        const ywContainerNoMustInput = {
            ...baseMustInput,
            message: `集装箱号不能为空`,
        };
        const list = [
            "trainNo",
            "flightNo",
            "truckNo",
            "tractorNo",
            "ywContainerNo",
        ];
        list.forEach((item) => {
            that.formRules[item] && delete that.formRules[item];
        });
        if (val === "2") {
            that.formRules = {
                ...that.formRules,
                tractorNo: tractorNoMustInput,
                ywContainerNo: ywContainerNoMustInput,
            };
        } else if (val === "3") {
            that.formRules = {
                ...that.formRules,
                trainNo: trainNoMustInput,
                ywContainerNo: ywContainerNoMustInput,
            };
        } else if (val === "4") {
            that.formRules = {
                ...that.formRules,
                truckNo: truckNoMustInput,
                tractorNo: tractorNoMustInput,
            };
        } else if (val === "5") {
            that.formRules = {
                ...that.formRules,
                flightNo: flightNoMustInput,
            };
        }
    };
    // 市场采购联网平台信息-境外运输方式变化
    if (item.colKey === "outbordTrafMode") {
        handleOutbordTrafMode();
    } else if (item.component === "search-select") {
        const { subKey, searchKey, subSearchKey } = item.options;
        if (subSearchKey) {
            const list = that.formSearchSelect[`${item.colKey}Options`];
            const findItem = list.find((citem) => citem[searchKey] === val);
            if (findItem) {
                that.formData[subKey] = findItem[subSearchKey];
                if (item.colKey === "freightName") {
                    // 如果是货代组货人名称，那么需要将地址反填回去
                    that.$emit("address-change", {
                        colKey: "stuffAddr",
                        type: 1,
                        value: findItem.frightAgentWarehouse || "",
                    });
                }
                // 如果是收发货人或者生产销售单位变化
                if (
                    [
                        "producerName",
                        "ownerName",
                        "producerSeller",
                        "consignee",
                    ].includes(item.colKey)
                ) {
                    const group1 = ["producerName", "ownerName"];
                    const group2 = ["producerSeller", "consignee"];
                    const [needColKey1, needColKey2] = group1.includes(
                        item.colKey,
                    )
                        ? group1
                        : group2;
                    // 判断关联配置项中是否有数据
                    const findData = (that.connectList || []).find(
                        (citem) =>
                            (item.colKey === needColKey1 &&
                                citem.consignee ===
                                    that.formData[needColKey1]) ||
                            (item.colKey === needColKey2 &&
                                citem.producerSeller ===
                                    that.formData[needColKey2]),
                    );
                    if (findData) {
                        that.formData[needColKey1] = findData.consignee;
                        that.formData[needColKey2] = findData.producerSeller;
                        // 把货代组货人名称,社会信用代码，地址反填回去
                        that.$emit("address-change", {
                            colKey: "freightName",
                            type: 2,
                            value: findData.freightName || "",
                        });
                        that.$emit("address-change", {
                            colKey: "freightSocialId",
                            type: 2,
                            value: findData.freightSocialId || "",
                        });
                        that.formData.stuffAddr = findData.stuffAddr;
                    }
                }
            }
        }
    } else if (["cusType", "declareType"].includes(item.colKey)) {
        that.$refs.formRef && that.$refs.formRef.clearValidate();
        const baseMustInput = {
            required: true,
            trigger: "change",
        };
        // 第一个对应的白卡号字段,第二个是境内运输方式字段
        const keyEnum = {
            cusType: ["inbordTrspmcNo", "inbordTrafModeName"],
            declareType: ["whiteCardNumber", "templateCusTrafModeName"],
        };
        const key0 = item.colKey;
        const [key1, key2] = keyEnum[key0];
        that.formRules[key1] && delete that.formRules[key2];
        // 如果是公路运输，并且是非一体化，那么白卡号必填
        if (val === "1" && that.formData[key2] === "公路运输") {
            that.formRules = {
                ...that.formRules,
                [key1]: {
                    ...baseMustInput,
                    message: "白卡号必填",
                },
            };
        } else {
            that.formRules = JSON.parse(JSON.stringify(that.formRules));
        }
    }
};

// 基础subValue
export const handleBaseSubValueChange = async ({ val, item, that }) => {
    // // 出口口岸改变
    // if (item.colKey === "templateExportPortName") {
    //     // console.log()
    //     const isHasFitPort = EXPORT_PORT_CUSTOMS_MAP_LIST.find(
    //         (item) => item[0] === val,
    //     );
    //     this.$nextTick(() => {
    //         if (isHasFitPort && !this.formData.templateExitPortName) {
    //             this.formData.templateExitPortName = isHasFitPort[3];
    //             this.formData.templateExitPort = isHasFitPort[1];
    //         }
    //     });
    // }
    // // 离境口岸改变
    // if (item.colKey === "templateExitPortName") {
    //     const isHasFitPort = EXPORT_PORT_CUSTOMS_MAP_LIST.find(
    //         (item) => item[1] === val,
    //     );
    //     this.$nextTick(() => {
    //         if (isHasFitPort && !this.formData.templateExportPortName) {
    //             this.formData.templateExportPortName = isHasFitPort[2];
    //             this.formData.templateExportPort = isHasFitPort[0];
    //         }
    //     });
    // }
    that.formData[item.options.subKey] = val;
    // 目的国改变，护照值变化
    if (item.colKey === "tradeCountryName") {
        getPassportList({
            pageIndex: 1,
            pageSize: 10000,
            countryCode: val,
        }).then((res) => {
            const passportList = apiCallback(res);
            let isFit = false;
            that.formSearchSelect.passportCodeOptions = (
                passportList || []
            ).map((item) => {
                if (item.passPortCode === that.formData.passportCode) {
                    isFit = true;
                }
                return {
                    label: item.passPortCode,
                    value: item.passPortCode,
                };
            });
            if (!isFit) {
                that.formData.passportCode = "";
            }
            that.initLoopList();
        });
    }
    // 离境口岸,出口口岸
    if (
        [
            "iePortName",
            "ciqEntyPortName",
            "templateExitPortName",
            "templateExportPortName",
        ].includes(item.colKey)
    ) {
        await that.$store.dispatch("assistant/getShipPortValidate", {
            vesselName: that.formData.shipName,
            voyageNo: that.formData.voyageNo,
            departurePort: that.formData.ciqEntyPortCode,
            iEPort: that.formData.iePort,
        });
        that.triggerValidatePort();
    } else if (
        [
            "inbordTrafModeName",
            "templateCusTrafModeName",
            "cusType",
            "declareType",
        ].includes(item.colKey)
    ) {
        const keyEnum = {
            // 第一个对应的白卡号字段,第二个是柜型字段,第三个是申报方式字段,第四个是箱号字段
            inbordTrafModeName: [
                "inbordTrspmcNo",
                "containerModelName",
                "cusType",
                "containerNo",
            ],
            templateCusTrafModeName: [
                "whiteCardNumber",
                "templateCtnTypeName",
                "declareType",
                "ctnNo",
            ],
        };
        // 境内运输方式的变化，
        // 如果是4-公路运输，并且是非一体化，那么白卡号必填，其他非必填
        // 如果是5-航空运输，那么柜型,箱号非必填,其他必填
        that.$refs.formRef && that.$refs.formRef.clearValidate();
        const baseMustInput = {
            required: true,
            trigger: "change",
        };
        const key0 = item.colKey;
        const [key1, key2, key3, key4] = keyEnum[key0];
        that.formRules[key1] && delete that.formRules[key1];
        that.formRules[key2] && delete that.formRules[key2];
        that.formRules[key4] && delete that.formRules[key4];
        if (that.formData[key0] === "公路运输" && that.formData[key3] === "1") {
            that.formRules = {
                ...that.formRules,
                [key1]: {
                    ...baseMustInput,
                    message: "白卡号必填",
                },
            };
        }
        if (that.formData[key0] !== "航空运输") {
            that.formRules = {
                ...that.formRules,
                [key2]: {
                    ...baseMustInput,
                    message: "柜型必填",
                },
                [key4]: {
                    ...baseMustInput,
                    message: "集装箱号必填",
                },
            };
        }

        that.formRules = JSON.parse(JSON.stringify(that.formRules));
    }
};

export function loadNoticeList() {
    return new Promise((resolve, reject) => {
        getNoticeList({
            pageNo: 1,
            pageSize: 50,
            status: "T",
            type: 18,
        }).then((res) => {
            const { records } = apiCallback(res);
            const cacheList = records.map((item) => ({
                content: item.title,
                timestamp: item.subtitle,
                key: item.id,
            }));
            this.notesList = cacheList;
            resolve(cacheList);
        });
    });
}

// 匹配文件名内容:中间连续三个字母或数字，且前后都是非字母数字
export function extractThreeDigitsFromFileName(fileName) {
    if (!fileName) {
        return "";
    }
    const match = String(fileName).match(
        /(?<![0-9A-Za-z])([0-9A-Za-z]{3})(?![0-9A-Za-z])/,
    );
    return match ? match[1] : "";
}
